export default __webpack_public_path__ + "f19c679e91ad7ca6f4d69c95929e1835.ttf";